import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { NumericFormat } from 'react-number-format'

import httpClient from '../../helpers/httpClient'
import { formatDate } from '../../helpers/formatDate'
import LoadingSpinner from '../../placeholders/LoadingSpinner'
import './UnitTransactionsSection.css'


export default function UnitTransactionsSection({ unit }) {
  const navigate = useNavigate()
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchTransactions = async () => {
      if (!unit?.id) return
      setLoading(true)
      try {
        const response = await httpClient.get(
          import.meta.env.VITE_API_URL + `/api/transactions/by-unit?unitID=${unit.id}`
        )
        setTransactions(response.data || [])
      } finally {
        setLoading(false)
      }
    }

    fetchTransactions()
  }, [unit?.id])

  return (
    <div className="popout_body__content_container" id="unit-transactions-section">
      <h2>Transactions</h2>
      <div className="table">
        <div className="table__header-6">
          <div className="table__header--field">Transaction</div>
          <div className="table__header--field">Reservation</div>
          <div className="table__header--field">Contract</div>
          <div className="table__header--field">Deed</div>
          <div className="table__header--field">Buyer(s)</div>
          <div className="table__header--field">Price</div>
        </div>
        <div className="table__rows_container">
          {loading ? (
            <LoadingSpinner />
          ) : transactions.map(transaction => (
            <div
              className="table__row-6"
              key={transaction.id}
              onClick={() => navigate(`/transactions/${transaction.id}`)}
            >
              <div className="table__row--field">#{transaction.id} {transaction.type || ''}</div>
              <div className="table__row--field">{transaction.reservation_date ? formatDate(transaction.reservation_date) : ''}</div>
              <div className="table__row--field">{transaction.contract_date ? formatDate(transaction.contract_date) : ''}</div>
              <div className="table__row--field">{transaction.deed_date ? formatDate(transaction.deed_date) : ''}</div>
              <div className="table__row--field">{(transaction.buyer_names || []).join(', ')}</div>
              <div className="table__row--field">
                <NumericFormat
                  value={transaction.transaction_price || 0}
                  thousandSeparator=" "
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  suffix=" €"
                  displayType="text"
                />
              </div>
            </div>
          ))}
          {!loading && transactions.length === 0 && (
            <div className="table__row-1">
              <div className="table__row--field">No transactions linked to this unit.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
